import { z } from "zod";

export const learningFontSchema = z.enum(["GRUND", "LA", "SAS", "VA"]);
export const learningDisplaySchema = z.object({
  learningFont: learningFontSchema,
  allowPrintHelp: z.boolean(),
}).strict();
export type LearningDisplay = z.infer<typeof learningDisplaySchema>;
export const defaultLearningDisplay: LearningDisplay = { learningFont: "GRUND", allowPrintHelp: true };
export const printHelpDurationMs = 30_000;
export const learningFontLabels: Record<LearningDisplay["learningFont"], string> = {
  GRUND: "Grundschrift (Druckschrift)", LA: "Lateinische Ausgangsschrift (LA)",
  SAS: "Schulausgangsschrift (SAS)", VA: "Vereinfachte Ausgangsschrift (VA)",
};

export function learningDisplayFrom(value: unknown): LearningDisplay {
  const parsed = learningDisplaySchema.safeParse(value);
  return parsed.success ? parsed.data : { ...defaultLearningDisplay };
}

export function runLearningDisplay(settings: unknown): LearningDisplay {
  return learningDisplayFrom(settings && typeof settings === "object" ? (settings as { learningDisplay?: unknown }).learningDisplay : undefined);
}

export function supportsLearningHandwriting(type: string) {
  return type !== "silbentrennung" && type !== "morphem-zerlegung";
}

export function exerciseDisplayItemKey(state: unknown): string {
  const value = state && typeof state === "object" ? state as { index?: unknown; phase?: unknown; submitted?: unknown } : {};
  if (value.phase === "complete" || value.submitted) return "";
  return typeof value.index === "number" ? String(value.index) : "0";
}
